import { get, post, patch } from '../lib/api';

export async function getDelayReasons() {
  return get(`/soil/pending-fields/delay/reasons`);
}

export async function updateDelayReason(aaid, reason) {
  return post(`/soil/pending-fields/delay/${aaid}`, { delayReasonId: reason });
}

export async function approveFields(fields) {
  const aaids = fields.map((f) => f.aaid);
  return post(`/soil/pending-fields/approve/${aaids.join(',')}`);
}

export async function rejectFields(fields) {
  const soilPoints = fields.map((f) => f.soilPoints).flat();
  return patch(`/soil/pending-fields/reject`, { soilPoints });
}

export async function rejectPoint(point) {
  return patch(`/soil/pending-fields/reject`, { soilPoints: [point] });
}

export async function getFields() {
  return get('/soil/pending-fields');
}
